import { http } from '@/http/axios.js';

export function getListAPI() {
  return http({
    url: '/admin/doc/instruction/list',
    method: 'get'
  })
}
// 详情
export function getDetailAPI(docKey) {
  return http({
    url: '/admin/doc/instruction/detail',
    method: 'get',
    params: { docKey }
  })
}
// 编辑
export function handleEditAPI(data) {
  return http({
    url: '/admin/doc/instruction/edit',
    method: 'post',
    data
  })
}
